import { Button, type ButtonProps } from '@chakra-ui/react';
import type { ReactNode } from 'react';

interface ContactOutlineButtonProps extends ButtonProps {
  children: ReactNode;
}

/**
 * Secondary (outline) button used across the contact drawer views. Thin wrapper
 * over the shared Button recipe with `variant="outline" colorPalette="primary"`.
 * The recipe supplies the 1px hairline, rounded-md and primary.700 label; only
 * the warm-hairline overrides stay local: `border.emphasized` (the #DEDACE
 * mockup border, not the palette's emphasized step) and a `whiteSmoke` hover.
 * The panel background, 12.5px label, heading font and custom focus ring keep the
 * render byte-identical. No shadow.
 */
const ContactOutlineButton: React.FC<ContactOutlineButtonProps> = ({ children, ...rest }) => (
  <Button
    variant="outline"
    colorPalette="primary"
    type="button"
    display="flex"
    alignItems="center"
    justifyContent="center"
    gap="1.5"
    borderColor="border.emphasized"
    bg="panelBg"
    fontFamily="heading"
    fontSize="12.5px"
    color="primary.700"
    cursor="pointer"
    _hover={{ bg: 'whiteSmoke' }}
    _focusVisible={{ outline: '2px solid', outlineColor: 'primary.900', outlineOffset: '1px' }}
    {...rest}
  >
    {children}
  </Button>
);

export default ContactOutlineButton;
